// extracted by mini-css-extract-plugin
module.exports = {"info":"_5de54bc"};